import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "@/store/store";
import { defaultResourceExplorerViewIdSelector } from "@/store/resource-explorer/selectors/all-resource-explorers/defaultResourceExplorerViewIdSelector";
import { setWidgetSetup } from "@/store/dashboards/dashboardsSlice";
import { normalizedCostWidgetSetupDefaultData } from "@/store/dashboards/utils/constants/normalizedCostWidgetSetupDefaultData";
import { getNormalizedCostWidgetSetupDataThunk } from "@/store/dashboards/thunks/widgets/normalized-cost-widget/getNormalizedCostWidgetSetupDataThunk";

export const initiateNormalizedCostWidgetThunk = createAsyncThunk(
  "dashboards/initiateNormalizedCostWidget",
  async (_: void, { dispatch, getState }) => {
    const state = getState() as RootState;

    const defaultViewId = defaultResourceExplorerViewIdSelector(state);

    if (!defaultViewId) {
      dispatch(setWidgetSetup(normalizedCostWidgetSetupDefaultData));
      return;
    }

    dispatch(
      setWidgetSetup({
        ...normalizedCostWidgetSetupDefaultData,
        viewId: defaultViewId,
      }),
    );

    dispatch(getNormalizedCostWidgetSetupDataThunk());
  },
);
